export default __webpack_public_path__ + "static/media/fire-icon.4fa0d634.svg";